import React, {useEffect, useState} from "react";
import { EntityId } from "@reduxjs/toolkit";
import { useAppSelector } from "../../../../store/hooks";
import { AddonTemplateInterface } from "../../../../store/mine_craft/addonTemplatesSlice";
import { filterOption } from "../../../../helpers/FormHelper";
import { selectCategoryEntities, selectCategoryIds } from "../../../../store/mine_craft/categoriesSlice";

import { Button, Form, Input, Radio, Select } from "antd";
import FileDropzone from "../../../../componets/FileDropzone";

interface propsInterface {
  params?: AddonTemplateInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const categories = useAppSelector(selectCategoryEntities);
  const categoryIds = useAppSelector(selectCategoryIds);

  const [form] = Form.useForm();
  const [subcategoriesIds, setSubcategories] = useState<any[]>([]);

  useEffect(() => {
    findSubcategoriesBy(params?.category_id)

    form.resetFields();
  }, [params, form]);

  function onChangeCategory(id: number) {
    findSubcategoriesBy(id);

    form.setFieldsValue({
      subcategory_id: categories && id ? categories[id]?.subcategories[0] : null
    });
  }

  function findSubcategoriesBy(id: number | undefined) {
    const ids = categories && id && categories[id]?.subcategories ? categories[id]?.subcategories : [];
    setSubcategories(ids || []);
  }

  const renderCategoryOption = (id: EntityId) => {
    const item = categories[id];

    if (!item) {
      return null;
    }

    return <Select.Option key={id} value={id} title={item.title}>{item.title}</Select.Option>
  }

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <div className='v-group-dropzone'>
        <FileDropzone name='thumbnail' label='Thumbnail' preview={params?.thumbnail_url} />
        <FileDropzone name='mcpack' label='Behavior Pack' preview={params?.mcpack_url} />
        <FileDropzone name='mcpack_second' label='Texture Pack' preview={params?.mcpack_second_url} />
      </div>

      <Form.Item name='title' label="Title">
        <Input placeholder='Title' />
      </Form.Item>

      <Form.Item
        name='category_id'
        label="Select a category"
      >
        <Select
          allowClear
          showSearch
          filterOption={filterOption}
          placeholder='Select a category'
          onChange={onChangeCategory}
        >
          {categories && categoryIds.map(renderCategoryOption)}
        </Select>
      </Form.Item>

      <Form.Item
        name='subcategory_id'
        label="Select a subcategory"
      >
        <Select
          allowClear
          showSearch
          filterOption={filterOption}
          defaultActiveFirstOption
          placeholder='Select a subcategory'
        >
          {categories && subcategoriesIds.map(renderCategoryOption)}
        </Select>
      </Form.Item>

      <Form.Item label="Pro" name='pro'>
        <Radio.Group>
          <Radio value={1}>Free</Radio>
          <Radio value={2}>Premium</Radio>
          <Radio value={3}>Ads</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item name='body' label="Body">
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item name='search_text' label="Search Text">
        <Input.TextArea rows={3} />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
